import gettext from 'i18n/gettext';
const flow = {
    name: gettext('Link Bank Account'),
    cancel: {
        state: 'holding.dashboard.bank-accounts',
    },
    complete: {
        label: gettext('Back to Overview'),
        state: 'holding.dashboard.bank-accounts.overview',
    },
    steps: [
        {
            key: 'account',
            state: 'holding.dashboard.bank-accounts.link.account',
            heading: gettext('Link Bank Account'),
            label: gettext('Choose Account Type'),
        },
        {
            key: 'details',
            state: 'holding.dashboard.bank-accounts.link.details',
            heading: gettext('Link Bank Account'),
            label: gettext('Enter Account Details'),
        },
        {
            key: 'review',
            state: 'holding.dashboard.bank-accounts.link.review',
            heading: gettext('Review Bank Account Details'),
            label: gettext('Review'),
            cancel: true,
            controls: {
                next: gettext('Link Account'),
            },
        },
        {
            key: 'complete',
            state: 'holding.dashboard.bank-accounts.link.complete',
            complete: true,
            label: gettext('Complete'),
        },
    ],
};
export default flow;



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/bank-accounts/states/bank-accounts/link/link-flow.ts